import React, { useEffect, useState } from "react";
import firebase from "firebase";
import url from "url";
import "./AppLoader.css";

import LoadingSpinner from "../LoadingSpinner";
import Header from "../header/Header";
import MenuButton from "../MenuButton/MenuButton";
import Menu from "../Menu/Menu";

const firebaseConfig = {
  apiKey: "AIzaSyAHk2pV-OysKeA2BkL03VvF4UHjt3v9rlQ",
  authDomain: "menoo-bb531.firebaseapp.com",
  databaseURL: "https://menoo-bb531.firebaseio.com",
  projectId: "menoo-bb531",
  storageBucket: "menoo-bb531.appspot.com",
  messagingSenderId: "24177596257",
  appId: "1:24177596257:web:523f1b35dec7426e9e5720",
  measurementId: "G-BBHHJ830JD",
};

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

const AppLoader = (props) => {
  // catch requested rest from url path
  const requestedRestId = window.location.pathname.replace("/", "");
  let restId = requestedRestId === "" ? "lasgangarras" : requestedRestId;

  const [rest, setRest] = useState(null);
  const [menu, setMenu] = useState(null);
  const [lang, setLang] = useState(null);

  useEffect(() => {
    const getRestData = async () => {
      const restSnapshot = await db.collection("rests").doc(restId).get();
      if (!restSnapshot.exists) {
        console.log("Error fetching restaurant info");
        return;
      }
      const menuSnapshot = await db
        .collection("rests")
        .doc(restId)
        .collection("menu")
        .get();
      if (menuSnapshot.docs <= 0) {
        console.log("Error fetching restaurant menu");
        return;
      }

      setRest(restSnapshot.data());
      // set lang as default if not selected
      if (!lang) {
        setLang(restSnapshot.data().langs[0]);
      }
      let menuAux = [];
      menuSnapshot.forEach((doc) => {
        menuAux.push({ ...doc.data(), id: doc.id });
      });
      setMenu(menuAux);
    };

    getRestData();
  }, []);

  if (!rest || !menu) {
    return (
      <div className="app-loader">
        <LoadingSpinner />
        <h2>Cargando</h2>
      </div>
    );
  } else {
    // get categories from all menu items, then use Set trick to remove duplicates
    let categories = menu.map((cat) => {
      return cat["category_" + lang];
    });
    categories = new Set(categories);
    categories = [...categories];

    return (
      <>
        <Header
          rest={rest}
          lang={lang}
          onChangeLang={(newLang) => setLang(newLang)}
        />
        <MenuButton categories={categories} lang={lang} />
        <Menu menu={menu} categories={categories} lang={lang} />
      </>
    );
  }
};

export default AppLoader;
